import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';
import ReactList from '../../common/components/ReactList';

import {clearSearchResults, getCareSheets, searchCareSheets, toggleSelectedPetType} from '../actions';
import {areCareSheetsValid, getSearchPhrase, getSearchResults, getSelectedPetTypes, getPetTypes} from '../selectors';

import customer from '../../customer';
const {getActivePermissions} = customer.selectors;

import search from '../../search';
const {SearchPanel} = search.components;

import CareSheetInfo from './CareSheetInfo';

import * as permissions from '../../common/userPermissions';

class CareSheetsPage extends React.Component {
  componentWillMount() {
    const accessPermission = this.props.activePermissions.find((permission) => {
      return permission === permissions.ACCESS_CARE_SHEETS;
    });
    if(!accessPermission)
    {
      this.props.actions.push('/labels');
    } 

    if(!this.props.careSheetsValid) {
      this.props.actions.getCareSheets();
    }
  }

  componentWillUnmount() {
    this.props.actions.clearSearchResults();
  }

  handleFormSubmit = (values) => {
    this.props.actions.searchCareSheets(values.searchPhrase);
  }

  renderItem = (index, key) => {
    return <CareSheetInfo key={key} careSheet={this.props.searchResults[index]}/>;
  }

  render() {
    const {actions, careSheetsValid, searchPhrase, searchResults, selectedPetTypes, petTypeList} = this.props;

    return (
      <div className="container-fluid main" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1>{I18n.t('CARE_SHEETS')}</h1>
          </div>
        </div>

        {!careSheetsValid && <div className="loading"/>} 
        {careSheetsValid &&
        <div className="row">
          <div className="col-lg-12">
            <h3 className="float-left search-pets-title">{I18n.t('SEARCH_PETS')}</h3>
            <SearchPanel itemList={petTypeList}
                         onSelectedItem={actions.toggleSelectedPetType} 
                         onSubmit={this.handleFormSubmit}
                         selectedItems={selectedPetTypes}/>

            {(searchResults.length === 0 && searchPhrase === '') && <div className="no-recent-care-sheets">
                <h1>{I18n.t('SEARCH_FOR_A_PET')}</h1>
            </div>}
            {(searchResults.length === 0 && searchPhrase !== '') && <div className="no-recent-care-sheets">
                <h1>{I18n.t('NO_RESULTS_TRY_AGAIN')}</h1>
            </div>}  


            {/*<h5>Recent</h5>*/}
            {searchResults.length > 0 && <h5>{I18n.t('RESULTS')} ({searchResults.length})</h5>}
          </div>
        </div>}

        <div className="row search-results care-sheets">
          <ReactList itemRenderer={this.renderItem} length={searchResults.length} type="uniform"/>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activePermissions: getActivePermissions(state),
    careSheetsValid: areCareSheetsValid(state),
    petTypeList: getPetTypes(state),
    searchPhrase: getSearchPhrase(state),
    searchResults: getSearchResults(state),
    selectedPetTypes: getSelectedPetTypes(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({clearSearchResults, getCareSheets, searchCareSheets, toggleSelectedPetType, push}, dispatch)
  };
}

CareSheetsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePermissions: PropTypes.array.isRequired,
  careSheetsValid: PropTypes.bool.isRequired,
  petTypeList: PropTypes.array.isRequired,
  searchPhrase: PropTypes.string,
  searchResults: PropTypes.array.isRequired,
  selectedPetTypes: PropTypes.array.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(CareSheetsPage);


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/CareSheetsPage.js
 **/